import { FC } from "react";
import { useTranslation } from "react-i18next";

import { AppliaSecretariatHeaderProps } from "./AppliaSecretariatHeader.type";

const AppliaSecretariatHeader: FC<AppliaSecretariatHeaderProps> = () => {
	const { t } = useTranslation();

	return (
		<div className="flex flex-col gap-14">
			<div className="flex flex-col items-center text-center gap-4">
				<h2>{t("pages.introduction.appliaSecretariat.title")}</h2>
				<p className="w-full md:max-w-[65%]">{t("pages.introduction.appliaSecretariat.intro")}</p>
			</div>
		</div>
	);
};

export { AppliaSecretariatHeader };